import styled from 'styled-components';

// Обёртка вокруг таблицы интеграций
export const TableWrapper = styled('div')`
  max-height: 520px;
  overflow: auto;
`;
